import { spacing } from '../helpers';

export const pageHeaderSpacingStyles = {
  margin: spacing(4, -1, 0),
  padding: spacing(0, 1, 2),
};
